import * as $ from 'jquery';

export default (function () {
    window.objUtils = {
        getValue(obj, str) {
            return str.split('.').reduce((o, d) => o[d], obj)
        }
    }
}());